@let logo = logoDetails();
@switch (logo.logoType) {
    @case ('TeamLogo') {
        <ms-participant-image
            class="popular-bets-participant-image"
            [participantImage]="logo.participantLogo"
            [sportId]="sportId()"
            [showLogoColor]="showLogoColor()" />
    }
    @case ('CompetitionLogo') {
        @if (logo.fallbackLogoUrl) {
            <img width="24" height="24" alt="competition-logo" [ngSrc]="logo.fallbackLogoUrl" />
        }
    }
    @case ('SportsLogo') {
        <vn-icon size="24" name="sports-{{ sportId() }}" />
    }
    @case ('ShieldIcon') {
        @if (logo.fallbackLogoUrl) {
            <div class="shield-icon fallback-color">
                <img width="19" height="19" alt="shield-logo" [ngSrc]="logo.fallbackLogoUrl" />
            </div>
        }
    }
    @case ('OpenBullets') {
        <vn-icon [name]="bulletIconName" [size]="bulletIconSize.toString()" />
    }
    @case ('RadioOff') {
        <vn-icon name="theme-radio-off" size="8" />
    }
}
